import {
  AccordionTypes,
  BreakPointCondition,
  UI,
  useBreakpointIf,
  HStack,
  VStack,
} from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';

import { PaidCustodyExplanation } from '../../../PaidCustodyExplanation';

import { PaidCustodyHeadItem } from './components/PaidCustodyHeadItem';
import { getPaidCustodyHeadItems } from './constants';
import { PaidCustodyProps } from './types';

export const ItemSeparator = () => {
  return <Box my={Spacing['stack.xxxs']} h="1px" backgroundColor={Color['neutral.lightest']} />;
};

export const PaidCustody = ({ item }: PaidCustodyProps) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  const [accordionState, setAccordionState] = useState<AccordionTypes.Status>('closed');

  const handleOpenMobileAccordion = () => {
    setAccordionState(accordionState === 'closed' ? 'opened' : 'closed');
  };

  const renderPaidCustodyHeadItems = () =>
    getPaidCustodyHeadItems(item).map((headItem, index) => (
      <PaidCustodyHeadItem key={index} {...headItem} isMobile={isMobile} />
    ));

  if (isMobile) {
    return (
      <UI.Accordion
        testId="alerts-info"
        status={accordionState}
        onPress={handleOpenMobileAccordion}
        hasShadow={false}
        containerProps={{
          m: Spacing['inset.xs'],
          mt: Spacing['stack.'],
          p: Spacing['inset.xs'],
          bgColor: Color.background,
        }}>
        <UI.Accordion.Visible w="full" flex={1}>
          <Pressable onPress={handleOpenMobileAccordion}>
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <UI.Text fontSize={Typography['fontsize.xs']} variant="semibold">
                Custódia remunerada-Aluguel turbo
              </UI.Text>
            </HStack>
          </Pressable>
        </UI.Accordion.Visible>
        <UI.Accordion.Expanded maxContentHeight="80vh">
          <VStack space={Spacing['stack.xxxs']} px={Spacing['inline.nano']}>
            <HStack justifyContent="space-between" alignItems="center">
              <UI.Text variant="semibold" color="neutral.black">
                Custódia remunerada
              </UI.Text>
              <UI.IconButton
                h="10px"
                icon="Close"
                testId="tooltip-button-close"
                iconColor={Color['neutral.dark']}
                iconSize="xxxs"
                onPress={() => setAccordionState('closed')}
              />
            </HStack>
            <VStack
              p={Spacing['inset.xs']}
              space={Spacing['stack.nano']}
              backgroundColor={Color.background}
              borderRadius={BoxBorder.heavy}
              w="full">
              {renderPaidCustodyHeadItems()}
            </VStack>
            {!!isMobile && <PaidCustodyExplanation />}
          </VStack>
        </UI.Accordion.Expanded>
      </UI.Accordion>
    );
  }

  return (
    <VStack
      p={Spacing['inset.xs']}
      space={Spacing['stack.nano']}
      backgroundColor={Color.background}
      borderRadius={BoxBorder.heavy}
      w="full">
      <HStack justifyContent="space-between">{renderPaidCustodyHeadItems()}</HStack>
    </VStack>
  );
};
